import { gql, useMutation } from '@apollo/client';

import { GET_BROKER_DETAILS } from './brokers.details.query';

// GraphQL mutation
const DELETE_BROKER_LICENSE_MUTATION = gql`
  mutation DeleteLicenseFromPerson(
    $person_uuid: String!
    $license_uuid: String!
  ) {
    deleteLicenseFromPerson(
      personUuid: $person_uuid
      licenseUuid: $license_uuid
    ) {
      result
      nodesDeleted
      relationshipsDeleted
    }
  }
`;

export function DeleteBrokerLicense() {
  const [DeleteLicenseFromPerson, { data, loading, error, reset }] =
    useMutation(DELETE_BROKER_LICENSE_MUTATION, {
      refetchQueries: [GET_BROKER_DETAILS],
      awaitRefetchQueries: true,
    });

  return {
    data,
    DeleteLicenseFromPerson,
    loading,
    error,
    reset,
  };
}
